import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import { Container, Header, Icon, Anchor, Button } from 'Components/core';
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import InfoBox from 'Components/InfoBox';
import ReadyToEnroll from 'Views/benefits/components/ReadyToEnroll';

import Card from 'Components/Card';
import CardContainer from 'Components/Card/CardContainer';
import CardHighlighted from 'Components/Card/CardHighlighted';

// Images
import WhatYourPlanCovers from './images/Pharmacy_Benefits_-_What_your_plan_covers.jpeg';
import HowYourPharmacyBenefitsWork from './images/Pharmacy_Benefits_-_How_your_pharmacy_benefits_work.jpeg';
import HowToSaveMoney from './images/Pharmacy_Benefits_-_How_to_save_money_on_medicine.jpeg';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { SubHeader, TitleHeader } from 'Components/core/Header';

const payDeductible_list = ['ded', 'dedComb', 'dedNo', 'dedMult'];
const preventiveDrugs_list = [
  'SpecPrev1',
  'SpecPrev2',
  'SpecPrev3',
  'SpecPrev4'
];
const shareCosts_list = ['share1', 'share2', 'share3'];

export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_PHARMACY_BENIFITS);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container
          seperation="24px"
          column
          maxWidth
          style={{ margin: 'auto', padding: '32px' }}
        >
          <TitleHeader>Pharmacy
            <SubHeader>
             Benefits
             </SubHeader>
             </TitleHeader>
          <InfoBox header="What your plan covers" image={WhatYourPlanCovers}>
            {!state.pharmacy?.summary && (
              <p>
                Getting the medicine you need is important for your health,
                whether you take a drug every day or only once in a while. Be
                sure to check the drug lists for your medicines to be sure
                they’re covered. This will help you save the most money.
              </p>
            )}
            {state.pharmacy?.summary && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state.pharmacy?.summary)
                }}
              ></p>
            )}

            <p>
              <b>Your plan includes:</b>
              <ul>
                {state?.pharmacy?.drugList?.link?.length > 0 && (
                  <li>
                    <div>
                      Your plan includes medicine on the following drug list(s)
                      including brand name and generic drugs:
                      <ul>
                        {state?.pharmacy?.drugList?.link?.map(drug => {
                          return (
                            <li>
                              <Anchor
                      style={{textDecoration:'underline'}}
                            code={CODES.PH_BFT_DRUG_LIST}
                                to={drug.url}
                                target="_new"
                              >
                                {drug.label}
                              </Anchor>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </li>
                )}

                <ul></ul>
                {preventiveDrugs_list.indexOf(
                  state?.pharmacy?.preventiveDrugs
                ) == -1 && state?.pharmacy?.preventiveDrugs && (
                  <li
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(state?.pharmacy?.preventiveDrugs)
                    }}
                  ></li>
                )}
                {preventiveDrugs_list.indexOf(
                  state?.pharmacy?.preventiveDrugs
                ) != -1 && (
                  <React.Fragment>
                    {state?.pharmacy?.preventiveDrugs == 'SpecPrev1' && (
                      <li>
                        You also have access to:
                        <br />
                        <ul>
                          <li>
                            68,000 pharmacies across the country plus an easy
                            home delivery option.
                          </li>
                          <li>
                            Most specialty drugs if you have an ongoing health
                            issue or serious illness. Look for "SP" or the
                            Specialty Pharmacy icon when viewing your plan's
                            drug list.
                          </li>
                          <li>
                            Some preventive drugs at little or no cost to you.
                          </li>
                        </ul>
                      </li>
                    )}
                    {state?.pharmacy?.preventiveDrugs == 'SpecPrev2' && (
                      <li>
                        You also have access to:
                        <ul>
                          <li>
                            68,000 pharmacies across the country plus an easy
                            home delivery option.
                          </li>
                          <li>
                            Some preventive drugs at little or no cost to you.
                          </li>
                        </ul>
                      </li>
                    )}
                    {state?.pharmacy?.preventiveDrugs == 'SpecPrev3' && (
                      <li>
                        You also have access to:
                        <ul>
                          <li>
                            68,000 pharmacies across the country plus an easy
                            home delivery option.
                          </li>
                          <li>
                            Most specialty drugs if you have an ongoing health
                            issue or serious illness. Look for "SP" or the
                            Specialty Pharmacy icon when viewing your plan's
                            drug list.
                          </li>
                        </ul>
                      </li>
                    )}

                    {state?.pharmacy?.preventiveDrugs == 'SpecPrev4' && (
                      <li>
                        You also have access to 68,000 pharmacies across the
                        country plus an easy home delivery option.
                      </li>
                    )}
                  </React.Fragment>
                )}

                {state?.pharmacy?.specialtyDrugs && (
                  <li
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(state?.pharmacy?.specialtyDrugs)
                    }}
                  ></li>
                )}
                {state?.pharmacy?.accessPharmacies && (
                  <li
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(state?.pharmacy?.accessPharmacies)
                    }}
                  ></li>
                )}
              </ul>
            </p>
          </InfoBox>
         { state?.pharmacy?.payDeductible  && state?.pharmacy?.shareCosts &&  <InfoBox
            header="How your pharmacy benefits work"
            image={HowYourPharmacyBenefitsWork}
          >
            {payDeductible_list.indexOf(state?.pharmacy?.payDeductible) ==
              -1 &&  state?.pharmacy?.payDeductible && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.payDeductible)
                }}
              ></p>
            )}
            {payDeductible_list.indexOf(state?.pharmacy?.payDeductible) !=
              -1 && state?.pharmacy?.payDeductible && (
              <React.Fragment>
                {state?.pharmacy?.payDeductible == 'ded' && (
                  <p>
                    Your plan comes with a pharmacy deductible, which is
                    separate from your medical deductible. That means you’ll pay
                    a set amount of drug costs out of your pocket before your
                    plan starts to share the cost of your covered medicine
                  </p>
                )}
                {state?.pharmacy?.payDeductible == 'dedComb' && (
                  <p>
                    Your plan comes with a combined medical and pharmacy
                    deductible. That means you’ll have to pay the full cost for
                    your covered drugs until you meet 100% of your annual
                    deductible. The cost you pay out of your pocket for covered
                    drugs and covered medical care will go towards meeting your
                    annual deductible. Your plan will start to share the cost of
                    your covered medicine and covered medical care after you
                    reach your deductible
                  </p>
                )}
                {state?.pharmacy?.payDeductible == 'dedNo' && (
                  <p>
                    Your plan doesn't require a pharmacy deductible. That means
                    your plan helps pay for medicine before you reach your
                    deductible
                  </p>
                )}
                {state?.pharmacy?.payDeductible == 'dedMult' && (
                  <p>
                    Before a plan starts to help pay for medicine, you may first
                    pay a set amount out of your pocket. This is your
                    deductible. You’ll want to check the plan details to see if
                    it has a: <br />
                    <br />
                    Pharmacy deductible: You first pay a set amount of drug
                    costs out of your pocket and it’s separate from a medical
                    deductible. You have to pay your full pharmacy deductible
                    before your plan starts to share the cost of your medicine.
                    <br />
                    <br />
                    Combined deductible: You first pay a set amount for both
                    covered medical care and drug costs out of your pocket.{' '}
                    <br />
                    <br />
                    No pharmacy deductible: Your plan helps pay for medicine
                    before you reach your deductible.
                  </p>
                )}
              </React.Fragment>
            )}
            {shareCosts_list.indexOf(state?.pharmacy?.shareCosts) == -1 && (
              <p
                dangerouslySetInnerHTML={{
                  __html: replaceAnchor(state?.pharmacy?.shareCosts)
                }}
              ></p>
            )}
            {shareCosts_list.indexOf(state?.pharmacy?.shareCosts) != -1 && (
              <React.Fragment>
                {state?.pharmacy?.shareCosts == 'share1' && (
                  <p>
                    You pay a set amount, or copay, for medicine. Your copay
                    will be based on which tier the drug is on.
                  </p>
                )}
                {state?.pharmacy?.shareCosts == 'share2' && (
                  <p>
                    You pay a certain percentage of the drug’s cost, which can
                    be different based on the pharmacy you use
                  </p>
                )}

                {state?.pharmacy?.shareCosts == 'share3' && (
                  <p>
                    {' '}
                    After you meet your deductible, your plan will share the
                    cost of medicine. Your options include plans with different
                    ways of sharing the cost:
                    <CardContainer>
                      <Card>
                        <Header>Copay</Header>
                        <p>
                          You pay a set amount, or copay, for medicine. Your
                          copay will be based on which tier the drug is on.
                        </p>
                      </Card>
                      <Card>
                        <Header>Coinsurance</Header>
                        <p>
                          You pay a certain percentage of the drug’s cost, which
                          can be different based on the pharmacy you use.
                        </p>
                      </Card>
                    </CardContainer>
                  </p>
                )}
              </React.Fragment>
            )}
          </InfoBox>}
          <InfoBox
            header="How to save money on medicine"
            image={HowToSaveMoney}
          >
            <p>
              Your plan comes with handy tools to help you get the best care and
              save money:
            </p>
            <CardContainer>
              <Card>
                <Icon size="2x">1</Icon>
                <p>
                  <b>Search the drug list. </b> Prescription medicines or drugs
                  are listed in groups called tiers. Lower-cost drugs and
                  generics are usually Tiers 1 and 2.
                </p>
              </Card>
              <Card>
                <Icon size="2x">2</Icon>
                <p>
                  <b>Price a medication. </b> Once you become a member, you can
                  compare retail drug costs at local pharmacies at{' '}
                  <Anchor
                    code={CODES.PH_BFT_SITE_BROWSE}
                    to={state.brandInfo.webLink}
                    target="_blank"
                  >
                    {state.brandInfo.website}.
                  </Anchor>
                </p>
              </Card>
              <Card>
                <Icon size="2x">3</Icon>
                <p>
                  <b>Use a pharmacy in your plan. </b> Be sure to use a pharmacy
                  in your plan – you’ll save money.
                </p>
              </Card>
            </CardContainer>
            <CardContainer>
              <Card>
                <Icon size="2x">4</Icon>
                <p>
                  <b>
                    Ask your doctor about generic or over-the-counter options.
                  </b>
                </p>
              </Card>
              {state?.pharmacy?.pharmacyHomeDelivery == true && (
                <Card>
                  <Icon size="2x">5</Icon>
                  {/* TODO: Take a look at this section as the PDF has tags */}
                  <p>
                    <b>Sign up for home delivery </b> and get up to a 90-day
                    supply delivered right to your door.
                  </p>
                </Card>
              )}
            </CardContainer>

            {state?.pharmacy?.pharmacyASO == true && (
              <Card>
                <b style={{ textAlign: 'left' }}>
                  {' '}
                  Save Money on non-covered medication{' '}
                </b>
                <p style={{ textAlign: 'left' }}>
                  Save money on some non-covered medications. If your
                  prescription isn’t covered by your plan, you may be able to
                  get a discount. Share your ID card at the pharmacy and the
                  available discount will automatically be applied.
                </p>
              </Card>
            )}

            {state?.pharmacy?.pharmacyFAQURL == true && (
              <CardHighlighted>
                <Header>Questions? </Header>
                <p style={{ textAlign: 'center' }}>
                  Call the Pharmacy Member Services phone number on your member
                  ID Card – we're available 24/7.
                </p>
              </CardHighlighted>
            )}
          </InfoBox>
          <ReadyToEnroll />
        </Container>
      )}
    </Subscribe>
  );
};
